/**
 * Look up a commission-matrix cell for a ticket-type/option combo. Keys are
 * the stable numeric ids (coerced to string), with a fallback to the option
 * NAME for legacy matrices keyed by name. Mirrors the backend's
 * `typeRow?.[String(id)] ?? typeRow?.[name]` (affiliateInvoiceCalculations.ts).
 */
export function getMatrixEntry(commissionMatrix, ticketTypeId, ticketOptionId, ticketOptionName) {
    const typeRow = commissionMatrix?.[String(ticketTypeId)];
    return typeRow?.[String(ticketOptionId)] ?? typeRow?.[ticketOptionName];
}

/**
 * Check if any cell in a commission matrix has an explicit `enabled` flag.
 * Used to distinguish new-style matrices (with sell permissions) from legacy ones.
 */
export function matrixHasExplicitEnabledFlags(commissionMatrix) {
    return Object.values(commissionMatrix || {}).some((row) =>
        Object.values(row || {}).some(
            (entry) => entry && Object.prototype.hasOwnProperty.call(entry, 'enabled'),
        ),
    );
}
